/////////////////////////////////////////////////
//
// Manages all Toolbar needs for Webshop
//
////////////////////////////////////////////////////////////

class Toolbar extends App.Component {

    constructor(container) {
        super($(container));
        this.mask = this.container.hasClass('use-mask');

        this.prepare();
    }

    unsetActiveItems() {
        this.container.find('li.selected').removeClass('.selected');
        this.container.find('li .active').removeClass('active');
        if (this.mask && App.Interface.Mask.active) {
            // App.Interface.Mask.hide();
        }
    }

    calculateTabPosition() {
        if (this.container.offset().top > $(window).height() /2) {
            this.container.attr('data-orientation', 'up');
        } else {
            this.container.attr('data-orientation', 'down');
        }
    }

    prepare() {
        var instance = this;

        this.calculateTabPosition();

        instance.container.on('click', '.toolbar-element-item .trigger', function(e) {
            var element = $(this);

            instance.calculateTabPosition();

            var parent = element.parent('li');

            if (!element.attr('href') || element.hasClass('js-is-xhr-request')) {
                if (parent.hasClass('selected')) {
                    instance.unsetActiveItems();
                } else {
                    instance.unsetActiveItems();
                    parent.addClass('selected');
                    element.addClass('active');

                    if (element.hasClass('js-is-xhr-request')) {
                        var container = parent.find('.toolbar-container');
                        if (!container.html()) {
                            container.load(element.attr('href'));
                        }
                        var size = $(window).height() - container.offset().top;
                        if (container.height() > size) {
                            container.css('max-height', size);
                        }
                    }

                    /*
                     * Mobile menu should interact with toolbar if active
                     * Menu will disappear
                     */
                    if (!element.hasClass('js-toggle-menu') && App.Menu.isMenuShown) {
                        // App.Menu.hide();
                    }

                    // if (instance.mask && !App.Interface.Mask.active && !element.hasClass('js-toggle-menu')) {
                    //     App.Interface.Mask.show();
                    // }
                }
                e.preventDefault();
            }
        });
        $(document).on('click', '.js-toolbar-close', function() {
            instance.unsetActiveItems();
        });

        App.wait('App.Interface.Mask', function(Mask) {
            Mask.onHide(function() {
                instance.unsetActiveItems();
            });
        });
    }
}
App.Components.register('.element-toolbar', Toolbar);
